/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["FOLDER"] = 0] = "FOLDER";
    DocumentType[DocumentType["REPORT"] = 1] = "REPORT";
})(DocumentType || (DocumentType = {}));
export function DocumentTypeFromJSON(json) {
    return DocumentTypeFromJSONTyped(json, false);
}
export function DocumentTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function DocumentTypeToJSON(value) {
    return value;
}
